module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.visible),
      expression: "visible"
    }]
  }, [_c('label', [_vm._v("\n        " + _vm._s(_vm.t(_vm.displayName)) + "\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "range-filter"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.value[0]),
      expression: "value[0]"
    }],
    staticClass: "controls form-control",
    class: _vm.errorClassMin,
    attrs: {
      "type": "number",
      "step": _vm.step,
      "min": _vm.minValue
    },
    domProps: {
      "value": (_vm.value[0])
    },
    on: {
      "change": _vm.onInput,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.value, 0, $event.target.value)
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.value[1]),
      expression: "value[1]"
    }],
    staticClass: "controls form-control",
    class: _vm.errorClassMax,
    attrs: {
      "type": "number",
      "step": _vm.step,
      "max": _vm.maxValue
    },
    domProps: {
      "value": (_vm.value[1])
    },
    on: {
      "change": _vm.onInput,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.value, 1, $event.target.value)
      }
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-a21864b6!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/filter/RangeComponent.vue
// module id = 1340
// module chunks = 2